import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext({
  sessionExpiredRole: null,
  clearSessionExpired: () => {}
});

export function useAuth() {
  return useContext(AuthContext);
}

/**
 * Centralises the auth_unauthorized window event into React state.
 * Components subscribe via useAuth() instead of adding their own window listeners.
 * http.js continues to dispatch 'auth_unauthorized' — no change required there.
 */
export function AuthProvider({ children }) {
  const [sessionExpiredRole, setSessionExpiredRole] = useState(null);

  useEffect(() => {
    const handleUnauthorized = (e) => {
      const role = e.detail?.role;
      if (role === 'proctor' || role === 'admin') {
        setSessionExpiredRole(role);
      }
    };
    window.addEventListener('auth_unauthorized', handleUnauthorized);
    return () => window.removeEventListener('auth_unauthorized', handleUnauthorized);
  }, []);

  const clearSessionExpired = () => setSessionExpiredRole(null);

  return (
    <AuthContext.Provider value={{ sessionExpiredRole, clearSessionExpired }}>
      {children}
    </AuthContext.Provider>
  );
}
